import React from "react";
import "./App.css";
import { useParams } from "react-router"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DirectoryTree from './DirectoryTree';
import PhotoGrid from './PhotoGrid';
import VideoGrid from "./VideoGrid";
import BlogPage from "./Blog";
import { getServerHost } from "./Utils";

function MediaApp({ mediaType }) {
  let { path } = useParams();

  const [dirs, setDirs] = React.useState([]);
  const [files, setFiles] = React.useState(null);

  React.useEffect(() => {
    fetch(getServerHost() + mediaType + "-root")
      .then((res) => res.json())
      .then((data) => {
        setDirs(data);
        data.map(dir => {
        });
      });
  }, []);

  //  State to track the currently selected directory (initially, the root)
  const [currentPath, setCurrentPath] = React.useState(path);

  React.useEffect(() => {
    if (currentPath) {
      console.log("Fetch /" + mediaType + "?path=" + currentPath);
      fetch(getServerHost() + mediaType + "?path=" + currentPath)
        .then((res) => res.json())
        .then((data) => {
          setFiles(data.files);
        });
    }
  }, [currentPath]);

  //  Function to handle directory selection
  const onSelect = (newPath) => {
    setCurrentPath(newPath);
    setFiles([]);
  };

  const [thumbnailSize, setThumbnailSize] = React.useState(250); // Initial thumbnail size
  const minThumbnailSize = 100;
  const maxThumbnailSize = 500;

  //  Handle thumbnail size change
  const handleThumbnailSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setThumbnailSize(Math.max(minThumbnailSize, Math.min(newSize, maxThumbnailSize))); // Clamp the size
  };

  // Refs for the dragger element
  const draggerRef = React.useRef(null);

  const [directoryWidth, setDirectoryWidth] = React.useState(200); // Initial width for the directory tree
  const minDirectoryWidth = 100; // Minimum width for the directory tree
  const maxDirectoryWidth = 800; // Maximum width for the directory tree

  // --- Dragging Logic ---
  React.useEffect(() => {
    const dragger = draggerRef.current;
    let isDragging = false;

    // Unified event handlers
    const startDrag = () => {
      isDragging = true;
      document.body.style.cursor = 'ew-resize'; // Change cursor while dragging (for mouse)
      // Add listeners to the document to ensure dragging works even if cursor leaves dragger
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', endDrag);
      document.addEventListener('touchmove', onMove, { passive: false }); // { passive: false } crucial for preventDefault
      document.addEventListener('touchend', endDrag);
      document.addEventListener('touchcancel', endDrag); // Handle cancelled touches
    };

    const onMove = (e) => {
      if (!isDragging) return;

      let clientX;
      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX; // Get X from the first touch point
        e.preventDefault(); // Prevent scrolling while dragging on touch devices
      } else {
        clientX = e.clientX; // Get X from mouse event
      }

      let newWidth = clientX;

      // Clamp the width within min/max bounds
      newWidth = Math.max(minDirectoryWidth, Math.min(newWidth, maxDirectoryWidth));

      setDirectoryWidth(newWidth);
    };

    const endDrag = () => {
      isDragging = false;
      document.body.style.cursor = 'default'; // Reset cursor
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', endDrag);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', endDrag);
      document.removeEventListener('touchcancel', endDrag);
    };

    const onMouseDown = (e) => {
      isDragging = true;
      document.body.style.cursor = 'ew-resize'; // Change cursor while dragging
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    if (dragger) {
      // Add mouse listeners
      dragger.addEventListener('mousedown', startDrag);
      // Add touch listeners
      dragger.addEventListener('touchstart', startDrag, { passive: false }); // { passive: false } for preventDefault
    }

    // Cleanup event listeners when component unmounts
    return () => {
      if (dragger) {
        dragger.removeEventListener('mousedown', startDrag);
        dragger.removeEventListener('touchstart', startDrag);
      }
      // Ensure all document listeners are removed
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', endDrag);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', endDrag);
      document.removeEventListener('touchcancel', endDrag);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div className="App">
      <link rel="shortcut icon" href="#"></link>
      <div className="photo-album">
        <div className="directory-tree-container" style={{ width: `${directoryWidth}px` }}>
          <div className="thumbnail-size-control">
            <label htmlFor="thumbnailSize">Thumbnail Size:</label>
            <input
              type="range"
              id="thumbnailSize"
              min={minThumbnailSize}
              max={maxThumbnailSize}
              value={thumbnailSize}
              onChange={handleThumbnailSizeChange}
            />
            <span className="thumbnail-size-value">{thumbnailSize}px</span>
          </div>
          <DirectoryTree directories={dirs} onSelect={onSelect} currentPath={currentPath} mediaType={mediaType} />
        </div>
        <div className="dragger" ref={draggerRef}></div> {/* Dragger element */}
        {mediaType == "photos" &&
          <PhotoGrid path={currentPath} photoList={files} thumbnailSize={thumbnailSize} />}
        {mediaType == "videos" &&
          <VideoGrid path={currentPath} videoList={files} thumbnailSize={thumbnailSize} />}
      </div>
    </div>
  );
}

function Photo() {
  let { photo } = useParams();
  const [img, setImg] = React.useState(null);

  React.useEffect(() => {
    const fetchPhoto = async () => {
      const res = await fetch(getServerHost() + "photo?photo=" + photo);
      const imageBlob = await res.blob();
      const imageObjectURL = URL.createObjectURL(imageBlob);
      setImg(imageObjectURL);
    }
    fetchPhoto();
    /*
      .then((res) => res.json())
      .then((data) => {
        setDirs(data);
        data.map(dir => {
        });
      });
    */
  }, []);

  return (
    <>
      {img &&
        <div style={{
          margin: '0px',
          height: '100%',
          backgroundColor: 'rgb(14, 14, 14)'
        }}>
          
          <img src={img} style={{
            display: 'block',
            WebkitUserSelect: 'none',
            margin: 'auto',
            cursor: 'zoomIn',
            width: '100%',
            height: 'auto',
          }} />
        </div>
      }
    </>
  );
}

function App() {
  React.useEffect(() => {
    document.title = 'Kayli Leia Blog';
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BlogPage />}></Route>
        <Route path="/blog" element={<BlogPage showPost={false} />}></Route>
        <Route path="/blog/post" element={<BlogPage showPost={true} />}></Route>
        <Route path="/blog/page/:page" element={<BlogPage showPost={false} />}></Route>
        <Route path="/blog/id/:id" element={<BlogPage showPost={false} />}></Route>
        <Route path="/photos" element={<MediaApp mediaType="photos" />}></Route>
        <Route path="/photos/:path" element={<MediaApp mediaType="photos" />}></Route>
        <Route path="/photo/:photo" element={<Photo />}></Route>
        <Route path="/videos" element={<MediaApp mediaType="videos" />}></Route>
        <Route path="/videos/:path" element={<MediaApp mediaType="videos" />}></Route>
        {/*
          <Route index element={<Home />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
          */}
      </Routes>
    </BrowserRouter>
  )
}

export default App;